import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgxMaskDirective } from "ngx-mask";

import { MatIconButton } from "@angular/material/button";
import { MatSuffix } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { ImageResolverPipe } from "../../../pipes/sharedpipes/image-resolver.pipe";
import { ChildControlPipe } from "../../../pipes/child-control.pipe";

@Component({
  selector: "app-registration-number",
  templateUrl: "./registration-number.component.html",
  imports: [
    ReactiveFormsModule,
    NgxMaskDirective,
    MatIconButton,
    MatSuffix,
    MatIcon,
    ImageResolverPipe,
    ChildControlPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationNumberComponent {
  id = input.required<string>();
  placeholder = input.required<string>();
  parentForm = input.required<FormGroup>();
  formControlKey = input.required<string>();

  confirmed = output();
  constructor() {}

  clear(): void {
    this.parentForm().get(this.formControlKey())?.setValue("");
  }
}
